define(['moduler'], function (Moduler) {
    'use strict';

    // google tag manager tracking

    return Moduler.create({
        defaults: {
            debugMode: false
        },

		init: function () {
            var self = this;

            document.querySelectorAll('a').forEach(function (link, i) {
                var path = link.pathname.toLowerCase();

                // #1. PDF/PNG Downloads
                var ext = path.indexOf('.pdf') == path.length - 4 ? 'PDF' : path.indexOf('.png') == path.length - 4 ? 'PNG' : null;
                if (ext != null) {
                    link.addEventListener('click', function (e) {
                        try {
                            self.track('Download', ext, self.splitPath(path).pop());
                        } catch (err) {
                            self.handleError(err);
                        }
                    });
                }

                // #2. contact us links (/xx/contact/)
                var contactUrls = ['contact', 'kontakt', 'contactez-nous', 'contatti', 'bize-ulasin', 'contacto', 'contato'];
                var pathParts = self.splitPath(path);
                if (link.href.indexOf('#') == -1 && pathParts.length > 1 && contactUrls.indexOf(pathParts[1]) > -1) {
                    link.addEventListener('click', function (e) {
                        try {
                            self.track('Contact Button', 'Contact', link.innerText);
                        } catch (err) {
                            self.handleError(err);
                        }
                    });
                }
            });

            document.querySelectorAll('.js-contactPage a').forEach(function (link, i) {
                // #3. telephone clicks
                if (link.href.toLowerCase().indexOf('tel:') == 0) {
                    link.addEventListener('click', function (e) {
                        try {
                            self.track('Telephone Contact', window.location.pathname);
                        } catch (err) {
                            self.handleError(err);
                        }
                    });
                }
                // #4. email clicks
                if (link.href.toLowerCase().indexOf('mailto:') == 0) {
                    link.addEventListener('click', function (e) {
                        try {
                            self.track('Email Contact', window.location.pathname);
                        } catch (err) {
                            self.handleError(err);
                        }
                    });
                }
            });

            document.querySelectorAll('form.js-newsSubscribeForm').forEach(function (form, i) {
                form.addEventListener('submit', function (e) {
                    try {
                        // #16. Subscribe to our newsfeed (cision news)
                        if (e.target.elements["SubscribeCisionNews"] && e.target.elements["SubscribeCisionNews"].checked) {
                            self.track('Subscription', 'Press & News');
                        }
                    } catch (err) {
                        self.handleError(err);
                    }
                });
            });

            // #6. 404 error page
            if (document.querySelector('.js-notFoundPage')) {
                try {
                    self.track('404 Error', window.location.pathname, document.referrer);
                } catch (err) {
                    self.handleError(err);
                }
            }

            // #7. share buttons
            document.querySelectorAll('a.Share-link').forEach(function (shareLink, i) {
                shareLink.addEventListener('click', function (e) {
                    try {
                        self.track('Share buttons', window.location.pathname, shareLink.href);
                    } catch (err) {
                        self.handleError(err);
                    }
                });
            });

            document.querySelectorAll('a.Button').forEach(function (buttonLink, i) {
                buttonLink.addEventListener('click', function (e) {
                    try {
                        if (buttonLink.href.indexOf('#') > -1) {
                            // #8. anchor click
                            self.track('Anchor click', buttonLink.innerText, buttonLink.href);
                        }
                        // #9. button click
                        var buttonType = buttonLink.classList.contains('Button--bordered') ? 'Outlined' : 'Solid';
                        self.track('Button click', buttonType, buttonLink.innerText);
                    } catch (err) {
                        self.handleError(err);
                    }
                });
            });

            document.querySelectorAll('a:not(.Button)').forEach(function (genericLink, i) {
                if (genericLink.href.indexOf('#') != genericLink.href.length - 1) {
                    genericLink.addEventListener('click', function (e) {
                        try {
                            if (window.location.host == genericLink.host) {
                                // #10. internal link click
                                self.track('Text Link', genericLink.innerText, genericLink.href);
                            } else {
                                // #11. outbound link click
                                var action = genericLink.closest('footer') ? 'Footer' : 'Not in footer';
                                self.track('Outbound Link', action, genericLink.href);
                            }
                        } catch (err) {
                            self.handleError(err);
                        }
                    });
                }
            });

            // #12. contact form submitted, custom logic as form.submit event is not triggered for epiforms
            if (typeof $$epiforms !== 'undefined') {
                //$$epiforms(document).ready(function () {
                    $$epiforms('.EPiServerForms').on('formsSubmitted', function (e) {
                        try {
                            self.track('Form Submit', document.title, window.location.href);
                        } catch (err) {
                            self.handleError(err);
                        }
                    });
                //});
            }

            // #13. Google Maps - Window Interactions
            document.querySelectorAll('.OfficeList-map a').forEach(function (officeMapLink, i) {
                officeMapLink.addEventListener('click', function (e) {
                    try {
                        self.track('Google Maps', 'Window Interaction');
                    } catch (err) {
                        self.handleError(err);
                    }
                });
            });

            // #14. Google Maps - Get Directions
            document.querySelectorAll('.js-officeDirection').forEach(function (officeDirectionLink, i) {
                officeDirectionLink.addEventListener('click', function (e) {
                    try {
                        self.track('Google Maps', 'Get Directions Click');
                    } catch (err) {
                        self.handleError(err);
                    }
                });
            });
        },

        handleError: function (error) {
            console.debug('gtm tracking error: ' + error);
        },

        splitPath: function (path) {
            return path.replace(/^\/+/, '').replace(/\/+$/, '').split('/');
        },

        trackData: function (data) {
            var self = this;
            if (self.options.debugMode) {
                console.log(data);
            } else {
                console.debug(data);
                dataLayer.push(data);
            }
        },

        track: function (category, action, label, value) {
            var self = this;
            self.trackData({
                'eventCategory': category,
                'eventAction': action,
                'eventLabel': label,
                'eventValue': value,
                'event': 'GAEvent'
            });
        }
    });
});